import { render, staticRenderFns } from "./ButtonsForm.vue?vue&type=template&id=1bb9e970"
import script from "./ButtonsForm.vue?vue&type=script&lang=js"
export * from "./ButtonsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports